import { createFileRoute } from '@tanstack/react-router';

import { z } from 'zod';

export const Route = createFileRoute('/_secured/external-data/integrations/')({
  validateSearch: z.object({
    channel: z.string().optional(),
    category: z.string().optional(),
    status: z.string().optional(),
    sort: z.string().optional(),
    search: z.string().optional(),
    tab: z
      .enum(['connections', 'virtualPlatforms'])
      .optional()
      .default('connections'),
  }),
});
